import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { canAddToCart } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import Typography from "@insite/mobius/Typography";
import UCSColors from "@ucs/Utils/UCSColors";
import * as React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

type OwnProps = WidgetProps & HasProductContext & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, props: HasProductContext) => ({
    productSettings: getSettingsCollection(state).productSettings,
    canAddToCart: canAddToCart(
        state,
        props.productContext.product,
        props.productContext.productInfo,
        state.pages.productDetails.configurationCompleted,
        state.pages.productDetails.variantSelectionCompleted,
    ),
});

const Container = styled.div`
    margin: 12px 0px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    justify-content: space-between;
    > * {
        display: inline-flex;
        width: auto;
    }
`;

const ProductDetailsSku: React.FC<OwnProps> = ({ productContext, productSettings, canAddToCart }) => {
    let availableMessage: string | undefined = "";

    if (productContext.productInfo.inventory && productContext.productInfo.inventory.inventoryAvailabilityDtos) {
        availableMessage = productContext.productInfo.inventory?.inventoryAvailabilityDtos[0].availability?.message;
    }

    return (
        <Container>
            <Typography size="15px" weight={400} color={UCSColors.gray04}>SKU #: {productContext.product.productNumber}</Typography>
            {availableMessage !== "" && (
                <Typography size="15px" weight={400} color="primary">{availableMessage}</Typography>
            )}
        </Container>
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(connect(mapStateToProps)(ProductDetailsSku)),
    definition: {
        displayName: "Product SKU",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
